import { render } from "./EditTattooModal.vue?vue&type=template&id=8c9c8162"
import script from "./EditTattooModal.vue?vue&type=script&lang=js"
export * from "./EditTattooModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__